export function getDefaultMap () {
  const mapElement = document.getElementById('map');
  return mapElement && mapElement.map;
}

export function getSubnav () {
  return document.querySelector('d-subnav');
}
